import { FormattedMessage } from 'react-intl'
import { Box } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'

function AdvancedOptionsSection({ titleId, children }: { titleId: string; children: React.ReactNode }) {
  return (
    <Box mt={3}>
      <Box mb={2} display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle2" component="div" display="flex" alignItems="center">
          <FormattedMessage id={titleId} />
        </Typography>
      </Box>
      {children}
    </Box>
  )
}

export default AdvancedOptionsSection
